import { Controller } from "@hotwired/stimulus"
import { Chart, ArcElement, DoughnutController, Tooltip } from "chart.js"

Chart.register(ArcElement, DoughnutController, Tooltip)

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    percent: Number
  }

  connect() {
    const rawPercent = Math.max(this.percentValue || 0, 0)
    const percent = Math.min(rawPercent, 100)

    const progressColor = rawPercent >= 100 ? "#E8A735" : "#226597"
    const remainingColor = rawPercent >= 100 ? "#E8A735" : "#E5E5E5"

    this.chart = new Chart(this.canvasTarget, {
      type: "doughnut",
      data: {
        datasets: [
          {
            data: [percent, 100 - percent],
            backgroundColor: [progressColor, remainingColor],
            borderWidth: 0,
            hoverOffset: 0
          }
        ]
      },
      options: {
        responsive: false,
        cutout: "70%",
        animation: false,
        events: [],
        plugins: {
          tooltip: { enabled: false },
          legend: { display: false }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
